export class DataService{
    personalTasks = [];
    completeTasks = [];
    constructor(){
        var item = window.localStorage.getItem('personal-tasks');
        this.personalTasks = item ? JSON.parse(item) : [];
    }
    getTasks(){
        return window.tasks.map(t => {
            const pt = this.personalTasks.find(x => x.id == t.id);
            if(pt){
                return {...t, personal: true};
            }
            return t;
        });
    }
    getPersonalTasks(){
        return this.personalTasks;
    }
    getUsername(){
        return window.localStorage.getItem('username');
    }
    getDarkMode(){
        var item = window.localStorage.getItem('darkMode');
        return item !== undefined ? item === "true" : false;
    }
    setDarkMode(darkMode){
        window.localStorage.setItem('darkMode', darkMode.toString());
    }
    setUsername(val){
        window.localStorage.setItem('username', val)
    }
    setUnlockedAreas(val){
        window.localStorage.setItem('unlockedAreas', JSON.stringify(val || []))
    }
    getUnlockedAreas(){
        var item = window.localStorage.getItem('unlockedAreas');
        return item ? JSON.parse(item) : [];
    }
    togglePersonalTask(task){
        var existing = this.personalTasks.find(x => x.name === task.name);
        if(existing){
            task.personal = false;
            this.personalTasks = this.personalTasks.filter(x => x.name !== task.name);
        } else {
            task.personal = true;
            this.personalTasks.push({...task});
        }
        window.localStorage.setItem('personal-tasks', JSON.stringify(this.personalTasks));
    }
    getFilters(){
        var item = window.localStorage.getItem('filters');
        return item ? JSON.parse(item) : {complete: "false"}
    }
    setFilters(filters){
        window.localStorage.setItem('filters', JSON.stringify(filters));
    }
    getOrd(){
        var item = window.localStorage.getItem('ord');
        return item ? JSON.parse(item) : {desc: true, key: 'difficulty'};
    }
    setOrd(ord){
        window.localStorage.setItem('ord', JSON.stringify(ord));
    }
}